var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.solar !== undefined)?_c('span',{staticClass:"c-icon",class:'c-icon--' + _vm.solar,attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"material-icons",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.Name))])}
var staticRenderFns = []

export { render, staticRenderFns }